import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon EditIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const EditIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path d="M23.5 7.3A1.7 1.7 0 0024 6a1.9 1.9 0 00-.5-1.2L19.3.6a1.8 1.8 0 00-1.2-.5 1.7 1.7 0 00-1.2.5l-2.3 2.2 6.6 6.7zM17 3.2l1.4-1.5 4 4L21 7.1zM7.2 23.5l13.2-13.1-6.7-6.7L.6 16.8 0 24zm-3.7-7.1a.3.3 0 01.1-.2L13.8 6a.3.3 0 01.2-.1 44.4 44.4 0 014.2 4.1.3.3 0 01-.1.2L7.8 20.4a.3.3 0 01-.2.1 44.4 44.4 0 01-4-4.1z" />
    </Icon>
  )
}
export default EditIcon
